// Accounts blacklisted from logging in to webapp
export const B_ACCOUNTS = [488, 56];
